/// <reference types="vite/client" />
import axios from 'axios'

// URL base da API (usa proxy do Vite em dev)
const API_URL = import.meta.env.VITE_API_URL || '/api'

// Instância do Axios
export const api = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor de request - adiciona token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('MONITOR_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Interceptor de response - trata erros e refresh token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    // Se 401 e não é retry, tenta refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      const refreshToken = localStorage.getItem('MONITOR_refresh_token')
      if (refreshToken) {
        try {
          const response = await axios.post(`${API_URL}/auth/refresh`, {
            refreshToken,
          })

          const { accessToken } = response.data
          localStorage.setItem('MONITOR_token', accessToken)

          originalRequest.headers.Authorization = `Bearer ${accessToken}`
          return api(originalRequest)
        } catch (refreshError) {
          // Refresh falhou, limpa storage e redireciona
          localStorage.removeItem('MONITOR_token')
          localStorage.removeItem('MONITOR_refresh_token')
          localStorage.removeItem('MONITOR_usuario')
          window.location.href = '/login'
          return Promise.reject(refreshError)
        }
      }

      // Sem refresh token, redireciona para login
      localStorage.removeItem('MONITOR_token')
      localStorage.removeItem('MONITOR_refresh_token')
      localStorage.removeItem('MONITOR_usuario')
      window.location.href = '/login'
    }

    return Promise.reject(error)
  }
)

export default api

